import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'country-flag',
    templateUrl: './country-flag.component.html',
    styleUrl: './country-flag.component.scss',
    standalone: true,
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CountryFlagComponent {
    /**
     * Country code
     */
    @Input({ required: true })
    code!: string;
}
